module.exports = __webpack_public_path__ + "img/secondCustom.f4a83ccf.svg";